/* global YT */

SC.community = (function () {
  var api = {};

  var init = function () {
    removeFontPlaceholder();
    getMoreArticles();
    bindEvents();
    sendEvent();
    copyShareUrl();
  };

  var getMoreArticles = function () {
    $('.get-more-articles').on('click', function (e) {
      e.preventDefault();
      var that = this;
      var $url = $(this).data('url');
      var $page = $(this).data('page') + 1;
      // update page num
      $(this).data('page', $page);

      $.ajax({
        type: 'get',
        url: $url,
        dataType: 'html',
        data: {
          p: $page
        },
        success: function (data) {
          // insert new article
          if ($(that).data('page') === $(that).data('pages-available')) {
            $('.get-more-articles').hide();
          }
          $(data).insertBefore('.get-more-articles');
        },
        error: function () {
          confirmation(null, 'oops! an error occurred while submitting your request. try that again!');
        }
      });
    });
  };

  var removeFontPlaceholder = function () {
    if ($('.sc-alphabet')) {
      $('.sc-alphabet').empty();
    }
  };

  var bindEvents = function () {
    $('.active-category').on('click', function (e) {
      e.preventDefault();
      if ($('.community-categories').css('display') === 'none') {
        $('.community-categories').show();
      } else {
        $('.community-categories').hide();
      }
    });

    $('.share-icons .share-icon, .share-icons .share-icon-small').on('click', function () {
      /**
       * mParticle event Tracking - social share - community article
       */
      var $button = $(this);
      var $container = $button.closest('.share-icons');
      var platform = $button.closest('.share-icon-link').data('platform');

      if ($container.hasClass('follow-icons')) {
        var location = $('.community-container').length ? 'Community Homepage' : 'Community Article';
        SC.analytics.mp.sendEvent('Follow', 'social', {'Platform': platform, 'Location': location}, platform);
      } else {
        var shareInfo = $container.data();
        var eventData = {
          'Platform': platform,
          'Location': shareInfo.location,
          'Article Title': shareInfo.articleTitle,
          'Share Type': shareInfo.shareType
        };
        SC.analytics.mp.sendEvent('Share', 'social', eventData, shareInfo.shareType);
      }
    });

    var lastScrollTop = 0;
    var btnTimeout;
    $(window).scroll(function () {
      if (btnTimeout) {
        clearTimeout(btnTimeout);
      }
      var start = $(this).scrollTop();
      if (start >= lastScrollTop) {
        $('.scroll-nav').fadeOut();
        $('.scroll-share-btns').hide();
        $('.share-overlay').fadeOut();
      } else if (($(window).width() >= 753) && ($(window).width() < 1009)) {
        if ($(window).scrollTop() < 368) {
          $('.scroll-nav').fadeOut();
          $('.share-overlay').fadeOut();
        } else {
          $('.scroll-nav').show();
          btnTimeout = setTimeout(function () {
            $('.scroll-nav').fadeOut();
            $('.share-overlay').fadeOut();
          }, 3000);
        }
      } else if ($(window).width() >= 1009 && $(window).width() < 1425 ) {
        if ($(window).scrollTop() < 512) {
          $('.scroll-nav').fadeOut();
          $('.share-overlay').fadeOut();
        } else {
          $('.scroll-nav').show();
          btnTimeout = setTimeout(function () {
            $('.scroll-nav').fadeOut();
            $('.share-overlay').fadeOut();
          }, 3000);
        }
      } else if ($(window).width() >= 1425) {
        if ($(window).scrollTop() < 564) {
          $('.scroll-nav').fadeOut();
          $('.share-overlay').fadeOut();
        } else {
          $('.scroll-nav').show();
          btnTimeout = setTimeout(function () {
            $('.scroll-nav').fadeOut();
            $('.share-overlay').fadeOut();
          }, 3000);
        }
      } else {
        $('.scroll-nav').show();
        btnTimeout = setTimeout(function () {
          $('.scroll-nav').fadeOut();
          $('.share-overlay').fadeOut();
        }, 3000);
      }
      lastScrollTop = start;
    });

    $('.scroll-share-btn').on('click', function (e) {
      e.preventDefault();
      clearTimeout(btnTimeout);
      $('.scroll-share-btns').toggle();
      $('.share-overlay').toggle();
    });

    $('.share-overlay').on('click', function () {
      $('.scroll-share-btns').hide();
      $(this).hide();
    });
  };

    // Create Youtube object for each iframe on page
  var $players = $('.player');
  var myPlayers = {};
  window.onYouTubePlayerAPIReady = function () {
    $.each($players, function (index, value) {
      myPlayers['player-' + index] = new YT.Player(value.id, {
        events: {
          'onReady': onPlayerReady()
        }
      });
    });
  };
  function onPlayerReady() {
    $.each($players, function (index) {
      $('.video-container-' + index).on('click', function () {
        var player = myPlayers['player-' + index];
        player.playVideo();
        $('.video-container-' + index).addClass('hide-pseudo');
      });
    });
  }

  // Load Youtube API script
  var tag = document.createElement('script');
  tag.src = '//www.youtube.com/player_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var copyShareUrl = function () {
    $('.share-url').on('click', function () {
      var myParent = $(this).parent();
      copyToClipboardMsg(document.getElementById('share-target'), myParent);
      $('.share-icon.share-url, .share-icon-small.share-url, .share-icon-large.share-url').removeClass('not-copied');
      $('.share-icon.share-url, .share-icon-small.share-url, .share-icon-large.share-url').addClass('copy-background');

      setTimeout(function () {
        $('.share-icon.share-url, .share-icon-small.share-url, .share-icon-large.share-url').addClass('not-copied');
        $('.share-icon.share-url, .share-icon-small.share-url, .share-icon-large.share-url').removeClass('copy-background');
      }, 2000);
    });
  };

    // helper functions
  function copyToClipboardMsg(elem, myParent) {
    var succeed = copyToClipboard(elem, myParent);

    if (!succeed) {
      $('#_hiddenCopyText_').hide();
      confirmation(undefined, 'Copy not supported or blocked.  Press Ctrl+c to copy.');
    } else {
      $('#_hiddenCopyText_').hide();
      confirmation(undefined, 'URL Copied!<br>');
    }
  }

  function copyToClipboard(elem, myParent) {
    // create hidden text element, if it doesn't already exist
    var targetId = '_hiddenCopyText_';
    var isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    var origSelectionStart;
    var origSelectionEnd;

    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement('textarea');
        target.style.position = 'absolute';
        target.style.minHeight = '0';
        target.style.border = 'none';
        target.style.padding = '0';
        target.style.backgroundColor = 'transparent';
        target.id = targetId;
        myParent.append(target);
      }
      target.textContent = elem.textContent;
    }

    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = '';
    }
    return succeed;
  }

  /**
   * Social event tracking - Old GA Account.
   * Track close of Annex banner on the homepage
   * Deprecated: Will be removed soon.
   * @returns {void}
   */
  var sendEvent = function () {
    $('.share-icon, .community-back-btn, .scroll-back-btn, .get-more-articles').on('click', function () {
      SC.analytics.ga.sendEvent($(this).attr('data-analytics-category'), $(this).attr('data-analytics-action'));
    });
    $('.community-category-header, .community-image-hero, .community-image, .community-article-title, .community-home-btn, .related-article-link, .more-soul-image, .more-soul-title-link, .instagram-image-link').on('click', function () {
      SC.analytics.ga.sendEvent($(this).attr('data-analytics-category'), $(this).attr('data-analytics-action'), $(this).attr('data-analytics-label'));
    });
  };

  init();
  return api;
})();
